import { Env } from '@env';
import * as Clipboard from 'expo-clipboard';
import { usePathname, useRouter } from 'expo-router';
import { Alert, Platform, Share, View } from 'react-native';
import Toast from 'react-native-toast-message';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { useCustomer } from '@/api/customers/use-customer';
import { isDesktop } from '@/core';
import { GREY_40 } from '@/style/colors';
import { Button, Input, showErrorMessage, Text } from '@/ui';

import { NavigationButton, NavigationButtonTypes } from '../navigation-button';

export default function Referrals() {
  const { styles, theme } = useStyles(stylesheet);
  const pathname = usePathname();
  const router = useRouter();

  const { data: customer } = useCustomer();

  const handleShare = async () => {
    const link = `${Env.BASE_URL}?ref=${customer?.referralCode}`;

    if (Platform.OS === 'web') {
      const copied = await Clipboard.setStringAsync(link);

      if (!copied) {
        showErrorMessage('Issue copying to clipboard');
      } else {
        Toast.show({
          text1: 'Copied to clipboard',
          type: 'success',
        });
      }
    }

    try {
      await Share.share({
        message: link,
      });
    } catch (error: any) {
      Alert.alert(error.message);
    }
  };

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: theme.colors.background_1,
        alignItems: 'center',
      }}
    >
      <View style={styles.container}>
        {isDesktop() ? (
          <View style={{ gap: 16 }}>
            {!pathname.includes('/partner') ? (
              <NavigationButton
                type={NavigationButtonTypes.back_with_text}
                onPress={() => {
                  if (pathname.includes('partner')) {
                    router.navigate('/partner/more');
                  } else {
                    router.navigate('/account');
                  }
                }}
              />
            ) : null}

            <Text type="largeTitle">Referral</Text>
          </View>
        ) : null}

        <Text tx="referrals.title" type="title1" />

        <Text
          tx="referrals.guestDescription"
          type="bodyRegular"
          style={{ color: GREY_40 }}
        />

        <View style={{ gap: 16 }}>
          <Input
            label="Share your referral link"
            value={`${Env.BASE_URL}?ref=${customer?.referralCode}`}
            disabled
          />

          <Button type="primary" tx="referrals.share" onPress={handleShare} />
        </View>

        <Text
          tx="referrals.partnerDescription"
          type="bodyRegular"
          style={{ color: GREY_40 }}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    paddingTop: 24,
    paddingLeft: 16,
    paddingRight: 16,
    gap: 16,
    backgroundColor: theme.colors.background_1,
    maxWidth: {
      xs: '100%',
      sm: 600,
      md: 800,
    },
    width: {
      xs: '100%',
      md: 600,
    },
  },
}));
